// BarChart.tsx
import React, { useState } from "react";

const days = ["S", "M", "T", "W", "T", "F", "S"];
const values = [50, 100, 75, 60, 80, 120, 90]; // Adjust heights
const agentCounts = [25, 40, 30, 35, 28, 50, 40];

export default function BarChart() {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  return (
    <div className="relative flex flex-col items-center justify-end rounded-xl w-full h-[100px]">
      <div className="flex items-end justify-between w-full gap-1 h-[60px] px-2">
        {values.map((value, i) => (
          <div
            key={i}
            className="relative flex flex-col items-center"
            onMouseEnter={() => setHoveredIndex(i)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            {/* Bar */}
            <div
              className={`w-1.5 sm:w-2 rounded-full transition-all duration-300 ${
                hoveredIndex === i ? "" : i % 2 === 0 ? "" : "bg-gray-300"
              }`}
              style={{
                height: `${Math.min(value, 50)}px`,
                background:
                  hoveredIndex === i || i % 2 === 0
                    ? "linear-gradient(135deg, hsl(151 65% 45%), hsl(151 65% 60%))"
                    : undefined,
              }}
            ></div>

            {/* Tooltip */}
            {hoveredIndex === i && (
              <div className="absolute -top-20 flex flex-col items-start bg-[#1f2937] text-white text-xs rounded-md shadow-lg px-3 py-2 z-10 w-32">
                <span className="text-right w-full text-gray-300 border-b border-gray-300 pb-1">
                  {days[i]}
                </span>
                <div className="flex items-center mt-1">
                  <span className="w-2 h-2 bg-indigo-500 rounded-full mr-2"></span>
                  <span>New Agents: {agentCounts[i]}</span>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Labels */}
      <div className="flex justify-between w-full mt-2 text-xs text-gray-700 px-2 h-6">
        {days.map((day, i) => (
          <span key={i} className="w-2 sm:w-3 text-center font-bold">
            {day}
          </span>
        ))}
      </div>
    </div>
  );
}
